module.exports = __webpack_public_path__ + "static/pid-ug-27-en-signcode-d677cbbca5b5574b786f249cfa4217ec.png";